// extracted by mini-css-extract-plugin
module.exports = {"premiumContainer":"premium_premiumContainer__38qDQ","premiumImage":"premium_premiumImage__1BAgB","premiumContent":"premium_premiumContent__2Oy8y"};